import { PLAN_ID } from "../../../utils/constanst";

const env = process.env.NODE_ENV;
const setData = false;
const setObj = obj => setData ? ({ ...obj }) : ({});
const isDevelopment = env === "development";
export const IdPlanSOAElectronico = 416;

export const InitPage = 0;

export const catalogosDefault = {
    marcas: [],
    modelos: [],
    anios: [],
    usos: [],
    coberturas: [],
    rates: [],
    departamentos:[],
    cuidades:[],
    clase:[]
}

export const tarificacionDefault = {
    itipopol: 'I',
    VigenciaPol: 'A',
    ncuotas: 1,
    marca: 0,
    modelo: -1,
    anio: 0,
    tipo: 0,
    cate: 0,
    usoo: 1,
    nasiento: 0,
    valn: 0,
    suma: 0,
    valnreal: 0,
    GPS: 0,
    dedu: 0,
    rsat: 1,
    auNuevo: 0,
    showDialogFail: false
};



const SOAMochaded = isDevelopment ? {
    idPlan: IdPlanSOAElectronico,
    moneda: 'U$',
    placa: 'M-00001',
    marca: 0,
    marcaDesc: "",
    modelo:'' ,
    modeloDesc: "",
    anio: "",
    colorVehiculo: 'Blanco',
    numeroChasis: 'cchdh444d554d4',
    numeroMotor: '215444',
    claseVehiculo:'',
    tipoIdentidad: "1",
    numeroIdentificacion: '570-050591-0000M',
    nombres: '',
    apellidos: '',
    telefonoCasa: '',
    telefonoPersonal: '',
    correoElectronico: '',
    departamento: 31,
    cuidad: 6,
    direccionDomicilio: '',
    estadoCivil:2,
    montoPagar: 0,
    montoPagarVisualizar: 0,
    esDomicilio: undefined,
    esDelivery: undefined,
    esTelepago: true,
    direccionEntrega: '',
    nombreTarjeta: 'Eddy Antonio Ortiz Amador',
    numeroTarjeta: '341111111111111',
    isAmex:false,
    expiracionTarjeta: '12/22',
    cvvTarjeta: '123',
    acceptaTermino: true,
    numeroOportunidad:"0001",
    numeroSolicitud:"",
    usarTarjeta: undefined,
    guardado:false,
    cargando:false,
} : {};

export const SOADefault =
{
    idPlan: IdPlanSOAElectronico,
    moneda: 'U$',
    placa: '',
    marca: -1,
    marcaDesc: "",
    modelo: -1,
    modeloDesc: "",
    anio: "",
    usoDelVehiculo: '',
    colorVehiculo: '',
    numeroChasis: '',
    numeroMotor: '',
    claseVehiculo:'',
    tipoIdentidad: "1",
    numeroIdentificacion: '',
    nombres: '',
    apellidos: '',
    telefonoCasa: '',
    telefonoPersonal: '',
    correoElectronico: '',
    departamento: '',
    cuidad: '',
    direccionDomicilio: '',
    estadoCivil:2,
    montoPagar: 0,
    montoPagarVisualizar: 0,
    esDomicilio: undefined,
    esDelivery: undefined,
    esTelepago: true,
    direccionEntrega: '',
    nombreTarjeta: '',
    numeroTarjeta: '',
    isAmex:false,
    expiracionTarjeta: '',
    cvvTarjeta: '',
    acceptaTermino: undefined,
    numeroOportunidad:"",
    numeroSolicitud:"",
    guardado:false,
    cargando:false,
    init: false,
    tarificado:false,
    datasheet: false,
    mensaje:'',
    usarTarjeta : undefined,
    tarificacion: { ...tarificacionDefault },
    catalogos: { ...catalogosDefault },
    setTarificacion: (obj) => { },
    setCatalogos: (obj) => { },
    tarificacionChangeHandler: (event) => { },
    ...setObj(SOAMochaded)
};


export const buildTarficacionData = (soa) => {   
    let data = {
        ...soa.tarificacion,
        cate: soa.tarificacion.auCategoria,
        nasiento: soa.tarificacion.auNumPasajeros,
        suma: soa.tarificacion.valn,
        tipo: soa.tarificacion.auTipo,
        modelo: soa.modelo,
        marca: soa.marca,
        anio: soa.anio,
        usoo:soa.usoDelVehiculo,
        //Codigos de descuento
        codigo2: 0,
        codigo5: 0,
        codigo8: 0,
        itipopol: 'I',
        VigenciaPol: 'A',

    }
    let coverageIdsStr ="[";
    soa.catalogos.coberturas.coverages.forEach((item) => {
        data[`Cob${item.idCob}`] = 1;
        coverageIdsStr = coverageIdsStr + `${item.idCob},`;
    });
    coverageIdsStr = coverageIdsStr.substring(0,coverageIdsStr.length-1) + "]";
    data["coverageIds"] = coverageIdsStr;
    return data;
}
